import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { TwoFactorNudgeBanner } from './TwoFactorNudgeBanner';

const navItems = [
  { to: '/', label: 'Overview', end: true },
  { to: '/plans', label: 'Plans' },
  { to: '/ai-config', label: 'AI Config' },
  { to: '/users', label: 'Users' },
  { to: '/captcha', label: 'Captcha' },
  { to: '/dashboard-scripts', label: 'Dashboard Scripts' },
  { to: '/audit-logs', label: 'Audit Log' },
  { to: '/settings/account', label: 'Account' },
];

export function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex">
      <aside className="w-60 bg-slate-900 text-slate-100 flex flex-col">
        <Link to="/" className="px-6 h-16 flex items-center gap-2 border-b border-slate-800">
          <img src="/bruno-logo.svg" alt="Bruno" className="h-8 w-8" />
          <div>
            <div className="font-semibold">Bruno</div>
            <div className="text-xs text-slate-400 -mt-0.5">Admin</div>
          </div>
        </Link>
        <nav className="flex-1 px-2 py-4 flex flex-col gap-1">
          {navItems.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              className={({ isActive }) =>
                `px-3 py-2 rounded-md text-sm ${isActive ? 'bg-slate-800 text-white' : 'text-slate-300 hover:bg-slate-800/50'}`
              }
            >
              {it.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-slate-800 p-4 text-xs text-slate-400">
          <div className="truncate text-slate-300 mb-1">{user?.email}</div>
          <button
            onClick={async () => {
              await logout();
              navigate('/login');
            }}
            className="hover:text-white"
          >
            Logout
          </button>
        </div>
      </aside>
      <div className="flex-1 flex flex-col overflow-hidden">
        <TwoFactorNudgeBanner />
        <main className="flex-1 px-8 py-8 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
